export enum MY_CLEANINGS_ZIP {
  CTA = "myCleaningsCTA",
  INPUT = "myCleaningsZipInput",
  WARNING_CONTAINER = "myCleaningsWarningContainer",
}

export enum MY_CLEANINGS_HOLIDAY {
  NOTIFICATION_CONTAINER = "myCleaningsHolidayNotificationContainer",
}

export enum MY_CLEANINGS_NAV {
  PREVIOUS = "myCleaningsNavPrev",
  UPCOMING = "myCleaningsNavUpcoming",
}

export enum MY_CLEANINGS_TABLE {
  ROW = "myCleaningsTableRow",
  ADDRESS = "myCleaningsTableAddress",
  TYPE = "myCleaningsType",
  AGENT = "myCleaningsTableBatmaid",
  DATE = "myCleaningsTableDate",
  REPETITION = "myCleaningsTableRepetition",
  DURATION = "myCleaningsTableDuration",
  PRICE = "myCleaningsTablePrice",
  BATMAID = "myCleaningsTableBatmaid",
  RATING = "myCleaningsTableRating",
  OPTIONS = "myCleaningsTableOptions",
  OPTIONS_DROPDOWN_ITEMS = "myCleaningTableDropdownOptionsItems",
  OPTION_ITEM = "myCleaningsTableOptionItem",
  OPTION_ITEM_KEY_INFO = "myCleaningsTableOptionItemKeyInfo",
  OPTION_ITEM_SPECIAL_INSTRUCTIONS = "myCleaningsTableOptionItemSpecialInstructions",
  OPTION_ITEM_DETAILS = "myCleaningsTableOptionItemDetails",
  TABLE = "myCleaningsTable",
  MOBILE_LOCATION_ITEM = "myCleaningsMobileLocationItem",
  MOBILE_JOB_ITEM = "myCleaningsMobileJobItem",
  MOBILE_JOB_ITEM_DOTS = "myCleaningsMobileJobDots",
  MOBILE_JOB_ITEM_DETAILS = "myCleaningsMobileJobItemDetails",
  INFO_MESSAGE = "myCleaningsInfoMessage",
  INFO_MESSAGE_PENDING_HOLIDAYS = "myCleaningsInfoMessagePendingHolidays",
}

export enum MY_CLEANINGS_V2 {
  ROW = "newMyCleaningsTableRow",
  LOCATION_SELECTOR = "newMyCleaningsLocationSelector",
  JOB_DETAILS_DRAWER = "newMyCleaningsJobDetailsDrawer",
  CLOSE_JOB_DETAILS_DRAWER = "newMyCleaningsCloseJobDetailsDrawer",
}

export enum HOLIDAY_AUTOMATION {
  SKIP_CLEANING = "holidayAutomationSkipCleaningButton",
  EDIT_CLEANING = "holidayAutomationEditCleaningButton",
  REPLACE_AGENT = "holidayAutomationReplacementButton",
  REPLACEMENT_MODAL = "holidayAutomationReplacementModal",
  REPLACEMENT_MODAL_CONTENT = "holidayAutomationReplacementModalContent",
}

export enum EMPLOYEE_ABSENCES_TABLE {
  EMPLOYEE = "employeeAbsencesEmployee",
  TYPE = "employeeAbsencesType",
  START_DATE_TIME = "employeeAbsencesStartDateTime",
  END_DATE_TIME = "employeeAbsencesEndDateTime",
}

export enum CLEANING_TYPES {
  HOME_CLEANING = "HOME_CLEANING",
  END_OF_TENANCY = "END_OF_TENANCY",
  B2B_CLEANING = "B2B_CLEANING",
}

export enum CLEANING_DETAILS {
  MODAL = "cleaningDetailsModal",
  STAR = "cleaningDetailsStar",
  STAR_FULL = "cleaningDetailsStarFull",
  STAR_EMPTY = "cleaningDetailsStarEmpty",
  GUARANTEE_INFO_LABEL = "cleaningDetailsGuaranteeInfoLabel",
  CLEANING_MATERIALS_INFO_LABEL = "cleaningDetailsCleaningMaterialsInfoLabel",
  // ACTIONS
  ACTION_CANCEL = "cleaningDetailsActionCancel",
  ACTION_SKIP_CLEANING = "cleaningDetailsActionSkipCleaning",
  ACTION_MANAGE_CLEANING = "cleaningDetailsActionManageCleaning",
  ACTION_CHANGE_REQUEST = "cleaningDetailsActionChangeRequest",
  ACTION_CHOOSE_ANOTHER_DATE = "cleaningDetailsActionChooseAnotherDate",
  ACTION_EDIT_AS_ADMIN = "cleaningDetailsActionEditAsAdmin",
  ACTION_EOT_EDIT_AS_ADMIN = "cleaningDetailsActionEotEditAsAdmin",
  ACTION_DOWNLOAD_INVOICE = "cleaningDetailsActionDownloadInvoice",
  ACTION_AUTO_REPLACED = "cleaningDetailsActionAutoReplaced",
  ACTION_AUTOMATIC_RESCHEDULE = "cleaningDetailsActionAutomaticReschedule",
  // ACTIONS SECTIONS
  ACTION_SECTION_KEY_PICK = "cleaningDetailsActionSectionKeyPick",
  ACTION_SECTION_SPECIAL_INSTRUCTIONS = "cleaningDetailsActionSectionSpecialInstructions",
  ACTION_SECTION_CREATE_CHECKLIST = "cleaningDetailsActionSectionCreateChecklist",
  ACTION_SECTION_EDIT_CHECKLIST = "cleaningDetailsActionSectionEditChecklist",
}

export enum CHECKLIST_WARNING_MODAL {
  NAME = "checklistWarningModal",
}

export enum CLEANINGS_BEYOND_PLANNING_WINDOW {
  ROOT = "cleaningsBeyondPlanningWindow",
  LOAD_MORE_BUTTON = "cleaningsBeyondPlanningWindowLoadMoreButton",
}
